export default "__VITE_ASSET__nPOv7Y7Z__"